import { AxiosResponse } from 'axios';
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import { authApiResponseSuccess, authApiResponseError } from './actions';
import { AuthActions } from './constants';

import { LOCAL_PROP_KEY } from '@components/PropSelector';
import { setLocalUser, setLocalToken } from '@helpers/api/apiCore';
import { login as loginApi } from '@helpers/api/auth';
import { getSelf } from '@helpers/api/users';
import { AuthToken } from '@models/auth';
import { APIDefinedErrorCls, ClientErrorCls } from '@models/errors';
import { User } from '@models/users';

/**
 * Login the user
 * @param {*} payload - username and password
 */
type LoginPayload = { payload: { username: string; password: string }; type: string };

function* login({ payload: { username, password } }: LoginPayload) {
  try {
    const respLogin: AxiosResponse<AuthToken> = yield call(loginApi, { username, password });
    const { access_token, token_type } = respLogin.data;
    setLocalToken(access_token);

    const respSelf: AxiosResponse<User> = yield call(getSelf);
    setLocalUser(respSelf.data);

    yield put(authApiResponseSuccess(AuthActions.LOGIN_USER, { access_token, token_type }));
  } catch (error) {
    if (error instanceof ClientErrorCls) {
      yield put(authApiResponseError(AuthActions.LOGIN_USER, { message: error.message, code: error.code }));
    } else if (error instanceof APIDefinedErrorCls) {
      yield put(authApiResponseError(AuthActions.LOGIN_USER, { detail: error.detail }));
    }
    setLocalToken(null);
    setLocalUser(null);
  }
}

/**
 * Logout the user
 */
function* logout() {
  try {
    setLocalToken(null);
    setLocalUser(null);
    localStorage.removeItem(LOCAL_PROP_KEY);
    yield put(authApiResponseSuccess(AuthActions.LOGOUT_USER, null));
  } catch (error) {
    console.error(error);
  }
}

export function* watchLoginUser() {
  yield takeEvery(AuthActions.LOGIN_USER, login);
}

export function* watchLogout() {
  yield takeEvery(AuthActions.LOGOUT_USER, logout);
}

function* authSaga() {
  yield all([fork(watchLoginUser), fork(watchLogout)]);
}

export default authSaga;
